import { FormControl, ValidationErrors } from '@angular/forms';
  
export class whitespaceValidator {
    static emptyInput(control: FormControl) : ValidationErrors | null {
        if((control.value as string || '').trim().length === 0){
            return {emptyInput: true}
        }
        return null;
    }
}